export enum SortType {
  NOT_SORTED,
  ASCENDING,
  DESCENDING
}
